// Shared YouTube URL helpers — covers watch (?v=), youtu.be, shorts,
// live and embed URL forms.
const ID_PATTERN = /(?:youtu\.be\/|v=|shorts\/|live\/|embed\/)([a-zA-Z0-9_-]{11})/;

export const extractYoutubeId = (url) => {
  const match = url?.match(ID_PATTERN);
  return match ? match[1] : null;
};

export const getYoutubeThumbnail = (link) => {
  const id = extractYoutubeId(link);
  return id
    ? `https://img.youtube.com/vi/${id}/maxresdefault.jpg`
    : "https://via.placeholder.com/640x360/674DA2/ffffff?text=Видео";
};
